import React, { useContext } from 'react';
import {Container, Row, Col} from 'react-bootstrap'
import Thumbnail from "../../components/thumbnail";
import Content from "../../components/content";
import aboutData from '../../data/AboutMe'
import {GlobalContext} from "../../handlers/GlobalContext";


const AboutMe = ({type}) => {
    const [ state, dispatch] = useContext(GlobalContext);

    const lang = state.locale.locale.lang;

    const get_host = (url) => {
        return url.replace(/^((\w+:)?\/\/[^\/]+\/?).*$/,'$1').replace(/\/$/,"").replace(/(^\w+:|^)\/\//, '');;
    }

    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }

    return (
        <div className={type !== 'page' ? 'section-padding section' : null}>
            <Container>
                {
                    !aboutData[lang] ? null : aboutData[lang].map((aCountry,idxCountry) => (
                        <Row className={'align-items-top'} key={"country_" + idxCountry}>
                            <Col lg={3}>
                                <Container>
                                    <Row>
                                        { Array.isArray(aCountry.thumb) ?
                                            aCountry.thumb.map((aThumb,idxThumb) => (
                                                <Col lg={12} key={'cntry_thumb_' + idxThumb}>
                                                    <Thumbnail classes={'about-thumbnail mb-md-30 mb-sm-30 mb-xs-30'} thumb={`about/${aThumb}`}/>
                                                    <br/>
                                                </Col>
                                            )) :
                                            <Col lg={12}>
                                                <Thumbnail classes={'about-thumbnail mb-md-30 mb-sm-30 mb-xs-30'} thumb={`about/${aCountry.thumb}`}/>
                                            </Col>
                                        }
                                    </Row>
                                </Container>
                            </Col>

                            <Col lg={9}>
                                <Content classes={'about-content'}>
                                    <h3 className="block-title">{aCountry.name}</h3>
                                    <p>{aCountry.bio}</p>
                                    <ul className="personal-info">
                                        { !!aCountry.address ? <li><span> {translate("about-section-address","Address")}:</span>{aCountry.address}</li> : null}
                                        { !!aCountry.phone ? <li><span>{translate("about-section-phone","Phone")}:</span>{aCountry.phone}</li> : null }
                                        { !!aCountry.fax ? <li><span>{translate("about-section-fax","Fax")}:</span>{aCountry.fax}</li> : null }
                                        { !!aCountry.email ? <li><span>{translate("about-section-email","E-mail")}:</span>{aCountry.email}</li> : null }
                                        { !!aCountry.web ?
                                            (aCountry.web.map((l,lIdx) => ( <li key={`web_${lIdx}`}><span>{translate("about-section-web","Web page")}:</span> <a href={l} target="_blank"> {get_host(l)} </a></li>  ) ))
                                         : null }
                                    </ul>
                                </Content>
                            </Col>
                            { idxCountry < (aboutData[lang].length-1) ? <Col lg={12}>
                                <hr/>
                            </Col> : null }
                        </Row>
                    ))
                }


            </Container>
        </div>
    );
};

export default AboutMe;